import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const tabsManager: ThemeUICSSObject = {
  '.labelBox': {
    cursor: 'pointer',
  },

  /* PREPEND HERE */
};

export default tabsManager;
